import { DataBean } from "../DataBean";

export class ObligationBudget extends DataBean {


    public async getObligationBudgetDocumentBudgetList(idDocument:any,paymentDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getObligationBudgetDocumentBudgetList_Number_java.util.Date", [idDocument,paymentDate]);
    }

 
}